import React, { useEffect, useState } from 'react'
import { utility } from '../../framework/utility/utilityProvider';
import { COLUMNSTYPE, LOCALSTORAGE_KEY, LOGEVENT, MODULE, PREFERENCE_ENTITYNAME, TOAST_TYPES } from '../../framework/constant/constant';
import * as API from '../../framework/API/api';
import BossDialog from '../../components/BossDialog';
import { EditPageHeader } from '../../components/EditPageHeader';
import { ConfirmAlert } from '../../ConfirmAlert';
import { useTranslation } from '../../locale/useTranslation';
import ToastNotification from '../../components/ToastNotification';
import ActionButton from '../../framework/forms/helpercomponents/buttons/ActionButton';

const SyncSeasonWithEpisodeForm = (props) => {

    const { dataItem, onClose } = props;
    const lang = useTranslation();
    const [columns, setColumns] = useState([]);
    const [selectedColumnNames, setSelectedColumnNames] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        let currentUserId = utility.getValue(LOCALSTORAGE_KEY.user_id);
        let columns = await API.getFormData(PREFERENCE_ENTITYNAME.syncSeasonWithEpisode, currentUserId) ?? [];
        if (columns?.length === 0) {
            setColumns([]);
            return;
        }
        setColumns(columns.filter((column) => column.type !== COLUMNSTYPE.hidden));
    };

    const onColumnSelect = (columnName) => {
        setSelectedColumnNames((prev) => {
            if (prev.includes(columnName)) {
                return prev.filter((name) => name !== columnName);
            }
            return [...prev, columnName];
        });
    };

    const onSelectAll = (e) => {
        setSelectedColumnNames(e.target.checked ? columns.map((column) => column.name) : []);
    };

    const handleSubmit = async (fieldNames = selectedColumnNames) => {
        if (!fieldNames.length) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Please select at least one column." });
            return;
        }

        ConfirmAlert(async () => {
            setIsLoading(true);
            const selectedColumns = columns
                .filter((column) => fieldNames.includes(column.name))
                .map((column) => ({ ...column, isUpdate: true }));

            const payload = {
                _id: dataItem?._id,
                fields: selectedColumns.map((column) => column.name)
            };

            let res = await API.syncSeasonMetadataWithEpisodesV2(payload);
            if (res.success) {
                let logData = { event: LOGEVENT.SYNC_SEASON_METADATA, module: MODULE.MEDIA_EPISODE_SEASON, data: payload, message: res.message };
                await API.SaveLogs(logData);
                ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: res.message });
                onClose(true);
            } else {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
            }
            setIsLoading(false);
        },
            () => { },
            lang.sync_metadata_to_episodes_label,
            lang.sync_metadata_to_episodes_confirmation_message
        );
    };

    const handleUpdateAll = () => {
        const allColumnNames = columns.map((column) => column.name);
        setSelectedColumnNames(allColumnNames);
        handleSubmit(allColumnNames);
    };

    const selectedColumns = columns.filter((column) => selectedColumnNames.includes(column.name));
    const allSelected = columns.length > 0 && selectedColumnNames.length === columns.length;

    return (
        <BossDialog
            width="760px"
            title="Sync Season with Episodes"
            onClose={() => onClose()}
        >
            <div className="d-flex align-items-start justify-content-between mb-2">
                <EditPageHeader
                    showTitle={false}
                    saveButtonTitle={lang.sync_label}
                    isLoading={isLoading}
                    onSubmit={handleSubmit}
                    onCancel={() => onClose()}
                />
                <div className="mt-1">
                    <ActionButton
                        type="button"
                        btnColor="success"
                        name={"Sync All"}
                        title={"Sync all columns"}
                        disabled={!columns.length}
                        isLoading={isLoading}
                        onClick={handleUpdateAll}
                    />
                </div>
            </div>
            <div className="row" style={{ minHeight: "360px" }}>
                <div className="col-6">
                    <div style={{ border: "1px solid #d7d7d7", height: "100%", backgroundColor: "#fff" }}>
                        <div className="d-flex align-items-center" style={{ padding: "8px 10px", borderBottom: "1px solid #e5e5e5", fontWeight: 600 }}>
                            <input
                                type="checkbox"
                                checked={allSelected}
                                onChange={onSelectAll}
                                style={{ width: "15px", height: "15px" }}
                            />
                            <span className="ml-2">Update</span>
                        </div>
                        <div style={{ maxHeight: "320px", overflowY: "auto" }}>
                            {columns.map((column) => (
                                <label
                                    key={column.name}
                                    className="d-flex align-items-center mb-0"
                                    style={{ padding: "8px 10px", borderBottom: "1px solid #f1f1f1", cursor: "pointer" }}
                                >
                                    <input
                                        type="checkbox"
                                        checked={selectedColumnNames.includes(column.name)}
                                        onChange={() => onColumnSelect(column.name)}
                                        style={{ width: "15px", height: "15px" }}
                                    />
                                    <span className="ml-2" style={{ flex: 1 }}>{column.label ?? column.name}</span>
                                </label>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="col-6">
                    <div style={{ border: "1px solid #d7d7d7", height: "100%", backgroundColor: "#fff" }}>
                        <div style={{ padding: "8px 10px", borderBottom: "1px solid #e5e5e5", fontWeight: 600 }}>
                            Selected Columns
                        </div>
                        <div style={{ maxHeight: "320px", overflowY: "auto", padding: "8px 10px" }}>
                            {selectedColumns.length === 0 && <div className="text-muted">No columns selected</div>}
                            {selectedColumns.map((column) => (
                                <div
                                    key={column.name}
                                    className="d-flex align-items-center"
                                    style={{ padding: "7px 0", borderBottom: "1px solid #f1f1f1" }}
                                >
                                    <span style={{ flex: 1 }}>{column.label ?? column.name}</span>
                                 </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-2" style={{ fontSize: "12px", color: "#b02a37", backgroundColor: "#f8d7da", padding: "6px 10px", borderRadius: "4px" }}>
                <span style={{ color: "red", fontWeight: "bold" }}>* </span>
                <strong>Note:</strong> Please ensure the season metadata is saved before syncing. Once synced, changes cannot be reverted.
            </div>
        </BossDialog>
    )
}

export default SyncSeasonWithEpisodeForm
